import React, { useState } from 'react';
import { Download, Smartphone, X } from 'lucide-react';
import { usePWAInstall } from '../../../hooks/usePWAInstall';
import { motion, AnimatePresence } from 'framer-motion';

export function InstallButton() {
  const { isInstallable, isInstalled, handleInstall } = usePWAInstall();
  const [showHelp, setShowHelp] = useState(false);

  if (isInstalled) return null;

  const handleClick = () => {
    if (isInstallable) {
      void handleInstall();
      return;
    }
    setShowHelp(true);
  };

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.03, y: -1 }}
        whileTap={{ scale: 0.97 }}
        onClick={handleClick}
        className="inline-flex items-center rounded-lg border border-emerald-200 bg-white px-4 py-2.5 font-medium text-emerald-700 shadow-lg transition-all hover:border-emerald-300 hover:bg-emerald-50"
      >
        <Smartphone className="mr-2 h-4 w-4" />
        <span className="hidden sm:inline">Install App</span>
        <span className="sm:hidden">Install</span>
      </motion.button>

      <AnimatePresence>
        {showHelp && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            className="absolute right-4 top-16 z-50 w-80 rounded-2xl border border-gray-200 bg-white p-5 text-left shadow-2xl sm:right-8"
          >
            <button
              onClick={() => setShowHelp(false)}
              className="absolute right-3 top-3 rounded-lg p-1 text-gray-400 transition hover:bg-gray-100 hover:text-gray-700"
              aria-label="Close install instructions"
            >
              <X className="h-4 w-4" />
            </button>
            <div className="flex items-start gap-3 pr-5">
              <div className="rounded-xl bg-emerald-50 p-2 text-emerald-700">
                <Download className="h-5 w-5" />
              </div>
              <div>
                <h2 className="font-semibold text-gray-900">Install NigeriaFx</h2>
                <p className="mt-1 text-sm leading-5 text-gray-600">
                  Open your browser menu and choose “Add to Home Screen” or “Install NigeriaFx”.
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
